export const getStyled = (theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.custom.colors.text,
  },
  paper: {
    backgroundColor: theme.custom.colors.total,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '8px',
    overflow: 'auto',
    maxHeight: '80vh',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },

  table: {
    backgroundColor: theme.custom.colors.defaultBackground,
    color: theme.custom.colors.text,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },
});
